export const TYPE_DATE_PICKER = 1;
